<template>
  <section
    :class="{
      'mt-11 grid w-full grid-cols-2 gap-x-30px lg:mt-16': true,
    }"
  >
    <div
      v-for="(linkGroup, index) in linksGroupData"
      :key="index"
      :class="{
        'list col-span-2 mb-50px flex flex-col text-center md:text-left lg:col-span-1 lg:mb-10 xl:col-span-2': true,
        'items-center justify-center rounded-5px border border-[#e7eaec] px-9 py-52px': true,
        'xl:items-start xl:justify-start xl:rounded-none xl:border-none xl:px-0 xl:py-0': true,
      }"
    >
      <h3
        :class="{
          'mb-10px text-xl font-extrabold leading-6 text-www-color-neutral-medium-dark': true,
        }"
      >
        {{ linkGroup?.title }}
      </h3>
      <CustomerSideBarLink
        v-for="(link, linkIndex) in linkGroup?.links"
        :key="linkIndex"
        v-bind="link"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import CustomerSideBarLink from '~/components/Atmos/CustomerSideBarLink/CustomerSideBarLink.vue';
import type { CustomerHomeQueryResult } from '~/sanity/types';
type LinksGroupProps = {
  linksGroupData: NonNullable<CustomerHomeQueryResult>['linksGroup'];
};
defineProps<LinksGroupProps>();
</script>

<style></style>
